// extracted by mini-css-extract-plugin
export default {"input":"ContactForm_input__VKvF2","textBox":"ContactForm_textBox__q+it8"};